import {SvgIcon} from "@material-ui/core";

export const CodeIcon = () => {
    return (
        <SvgIcon style={{marginTop: 7, marginRight: 7}} xmlns="http://www.w3.org/2000/svg" width="522.468" height="392.019" viewBox="0 0 522.468 392.019">
            <g id="code" transform="translate(0 -65.225)">
                <g id="Group_3" data-name="Group 3">
                    <path id="Path_5" data-name="Path 5" d="M325.762,70.513l-17.706-4.854a7.975,7.975,0,0,0-6.707.715,9.285,9.285,0,0,0-4.429,5.568L190.426,440.53a8.552,8.552,0,0,0,.715,6.995,9.267,9.267,0,0,0,5.568,4.425l17.7,4.856a7.952,7.952,0,0,0,6.71-.712,9.3,9.3,0,0,0,4.425-5.564l106.5-368.594a8.56,8.56,0,0,0-.716-7A9.266,9.266,0,0,0,325.762,70.513Z"/>
                    <path id="Path_6" data-name="Path 6" d="M166.167,142.465a9.028,9.028,0,0,0-2.856-6.567l-14.277-14.276a8.976,8.976,0,0,0-13.134,0L2.856,254.666a8.977,8.977,0,0,0,0,13.133L135.9,400.843a8.982,8.982,0,0,0,13.134,0l14.277-14.268a8.977,8.977,0,0,0,0-13.133L51.107,261.233l112.2-112.2A9.017,9.017,0,0,0,166.167,142.465Z"/>
                    <path id="Path_7" data-name="Path 7" d="M519.614,254.663,386.567,121.619a8.975,8.975,0,0,0-13.133,0l-14.271,14.275a8.989,8.989,0,0,0,0,13.134l112.206,112.2L359.163,373.442a8.988,8.988,0,0,0,0,13.133l14.271,14.268a8.981,8.981,0,0,0,13.133,0L519.614,267.8a8.986,8.986,0,0,0,0-13.137Z"/>
                </g>
            </g>
        </SvgIcon>
    )
}

export const HeartIcon = () => {
    return (
        <SvgIcon style={{margin: '0 8px'}} xmlns="http://www.w3.org/2000/svg" width="391.837" height="320.787" viewBox="0 0 391.837 320.787">
            <g id="heart" transform="translate(0 -35.525)">
                <path id="Path_8" data-name="Path 8" d="M285.257,35.528a107.1,107.1,0,0,1,106.58,106.58c0,107.624-195.918,214.2-195.918,214.2S0,248.165,0,142.108A106.58,106.58,0,0,1,106.58,35.528h0a105.534,105.534,0,0,1,89.339,48.065A106.578,106.578,0,0,1,285.257,35.528Z" fill="#d7443e"/>
            </g>
        </SvgIcon>
    )
}
